import { Stack } from 'expo-router';
import Header from '@/components/Layout/Header';

const StackLayout = () => {
  return <Stack screenOptions={{ header: () => <Header withProfile={false} /> }} />;
};

export default StackLayout;
